export const difference = (base: Set<any>, other: Set<any>) => {
  const differenceSet = new Set();
  base.forEach(elem => {
    if (!other.has(elem)) {
      differenceSet.add(elem);
    }
  });
  return differenceSet;
};

export const intersection = (setA: Set<any>, setB: Set<any>) => {
  const intersectionSet = new Set();
  setB.forEach(elem => {
    if (setA.has(elem)) {
      intersectionSet.add(elem);
    }
  });
  return intersectionSet;
};
